module.exports = __webpack_public_path__ + "img/chair_170.7a75051e.jpg";